import { styled } from "styled-components";
import { Page } from "../../../components/layout/page/page.component";
import { Ticket } from "../components/ticket.component";
import { FloatingActionButton } from "../../../components/ui/fab/fab.component";
import { MdAdd } from "react-icons/md";
import { colors } from "../../../theme/colors";
import { useCallback, useEffect, useState } from "react";
import { Form, Select } from "antd";
import { handleResponse } from "../../../utils/functions/http/handleResponse";
import { axios } from "../../../api/axios";
import { Ticket as TicketModel } from "../../../models/ticket.model";
import { useAtom } from "jotai";
import { helpAtom } from "../../../atoms/help.atom";
import { Row } from "../../../components/ui/grid/row.component";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { FilmProfile } from "../../../models/film-profile.model";
import moment from "moment";

export const ViewAllTickets = () => {
  const [tickets, setTickets] = useState<TicketModel[]>([]);
  const [filters, setFilters] = useState<
    { type: "film" | "status"; value: string }[]
  >([]);
  const [films, setFilms] = useState<FilmProfile[]>([]);

  const [{ created }, setHelp] = useAtom(helpAtom);

  const matchesFilters = useCallback(
    (ticket: TicketModel) => {
      return (
        filters
          .map((filter) =>
            filter.type === "film"
              ? ticket.film === filter.value
              : ticket.status === filter.value
          )
          .filter((el) => el).length === filters.length
      );
    },
    [filters]
  );

  useEffect(() => {
    axios
      .get<FilmProfile[]>("/client/get/films/me")
      .then((resp) => {
        setFilms(resp.data);
      })
      .catch(handleResponse);
  }, []);

  useEffect(() => {
    axios
      .get<TicketModel[]>("/client/tickets")
      .then((resp) => {
        const tickets = resp.data.sort((ticketA, _) =>
          ticketA.status === "open" ? -1 : 1
        );
        setTickets(tickets);
      })
      .catch(handleResponse);
  }, []);

  useEffect(() => {
    if (created) {
      window.location.reload();
    }
  }, [created]);

  return (
    <Page>
      <Spacer direction="bottom" size={75} />
      <Row $gap={20}>
        <Form.Item label="Film" layout="vertical">
          <Select
            placeholder="Filter by film"
            options={films.map((film) => ({
              label: film.title,
              value: film.title,
              id: film.id,
            }))}
            onChange={(_, option) => {
              if (!option)
                return setFilters(
                  filters.filter((filter) => filter.type !== "film")
                );

              setFilters([
                ...filters.filter((filter) => filter.type !== "film"),
                {
                  type: "film",
                  value: Array.isArray(option) ? option[0]?.id : option?.id,
                },
              ]);
            }}
            showSearch
            allowClear
          />
        </Form.Item>
        <Form.Item label="Status" layout="vertical">
          <Select
            placeholder="Filter by status"
            options={[
              { label: "Open", value: "open" },
              { label: "Closed", value: "closed" },
            ]}
            onChange={(value) => {
              if (!value)
                return setFilters(
                  filters.filter((filter) => filter.type !== "status")
                );

              setFilters([
                ...filters.filter((filter) => filter.type !== "status"),
                { type: "status", value },
              ]);
            }}
            showSearch
            allowClear
          />
        </Form.Item>
      </Row>
      <TicketsContainer>
        {tickets.map((ticket) =>
          matchesFilters(ticket) ? (
            <Ticket
              status={ticket.status}
              key={ticket.id}
              id={ticket.id}
              title={ticket.title}
              description={ticket.description}
              createdAt={moment(ticket.created_at)}
              film={ticket.object?.detail}
            />
          ) : null
        )}
        {tickets.length === 0 ? <NoItems>No tickets created!</NoItems> : null}
      </TicketsContainer>
      <FloatingActionButton onClick={() => setHelp({ showHelpModal: true })}>
        <MdAdd size={25} color={colors.white.hex} />
        Create Ticket
      </FloatingActionButton>
    </Page>
  );
};

const TicketsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FormItem = styled(Form.Item).attrs({})`
  /* margin-bottom: 4rem; */
`;

const NoItems = styled.span`
  font-size: 1.6rem;
  font-weight: 500;
  color: ${colors.text.hex};
  text-align: center;
`;
